import { render, staticRenderFns } from "./courseCurricula.vue?vue&type=template&id=29faec82&"
import script from "./courseCurricula.vue?vue&type=script&lang=js&"
export * from "./courseCurricula.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports